<template>
    <div class="card mt-3" style="margin-bottom:10px">
        <div class="card-body">
            <div class="row">
                <h6 style="background: #0078be!important;" class="card-title bg-primary text-white w-100 p-1">
                    DETALLADO DE ATENCIONES
                </h6>

                <div class="col-6 mb-3">
                    <label for="startDate" class="form-control-label" style="font-weight: bold; font-size: 12px;">
                        Fecha Inicial (*):
                    </label>
                    <input type="date" id="startDate" class="form-control" v-model="startDate"
                        @change="validateDates" />
                </div>

                <div class="col-6 mb-3">
                    <label for="endDate" class="form-control-label" style="font-weight: bold; font-size: 12px;">
                        Fecha Final (*):
                    </label>
                    <input type="date" id="endDate" class="form-control" v-model="endDate" @change="validateDates" />
                </div>

                <div class="col-12">
                    <div class="col-12 d-flex justify-content-center">
                        <div
                            class="col-12 col-md-4 col-lg-4 col-xl-4 col-sm-12 d-flex justify-content-center align-items-center">
                            <button :disabled="!isDateRangeValid" @click="download" class="btn btn-primary btn-sm mt-2"
                                :style="{ width: '100%' }">
                                Descargar
                            </button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import ExcelJS from 'exceljs';
import moment from 'moment-timezone';

export default {
    name: "Reportes",
    data() {

        let datos = JSON.parse(localStorage.getItem("userData"));

        return {
            user: datos.email,
            isDateRangeValid: false,
            startDate: '',
            endDate: '',
        };
    },

    computed: {
        userRole() {
            const encryptedRole = localStorage.getItem("aut");
            if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
                return this.$encryptBackoffice.decrypt(encryptedRole);
            }
            return null;
        },
    },

    methods: {
        validateDates() {
            if (!this.startDate || !this.endDate) {
                this.isDateRangeValid = false;
                return;
            }

            if (this.startDate > this.endDate) {
                alert("La fecha inicial no puede ser mayor que la fecha final.");
                this.isDateRangeValid = false;
            } else {
                this.isDateRangeValid = true;
            }
        },

        download() {
            if (this.isDateRangeValid) {
                console.log("Descargando datos desde", this.startDate, "hasta", this.endDate);
                this.getDescDesHast();
            } else {
                console.log("Rango de fechas no válido");
            }
        },

        async getDescDesHast() {
            console.log('Descargando archivo');

            this.showLoading2('Generando, por favor espere...')

            const encryptedRole = localStorage.getItem("aut");
            let rol = '';

            if (encryptedRole && this.$encryptBackoffice && this.$encryptBackoffice.decrypt) {
                rol = this.$encryptBackoffice.decrypt(encryptedRole);
            }

            this.$https.post('/estadistica/getDownloaderConsultas', { desde: this.startDate, hasta: this.endDate, email: this.user, rol: rol }, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {

                if (response.data.code === 200) {

                    if (response.data.datos.length > 0) {

                        this.creandoExcel(response.data.datos)

                    } else {

                        this.$swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'No hay datos para descargar',
                            confirmButtonColor: '#3085d6'
                        })

                        return
                    }
                }
            })



        },

        async creandoExcel(datos) {
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Reporte');

            // 🔹 Configuración de página (márgenes, orientación y tamaño de hoja)
            worksheet.pageSetup = {
                margins: {
                    left: 0.200,    // 🔹 0.53 cm convertido a pulgadas
                    right: 0.200,   // 🔹 0.53 cm convertido a pulgadas
                    top: 0.5,     // 🔹 0.53 cm convertido a pulgadas
                    bottom: 0.208,  // 🔹 0.53 cm convertido a pulgadas
                    header: 0.118,  // 🔹 0.3 cm convertido a pulgadas
                    footer: 0.118   // 🔹 0.3 cm convertido a pulgadas
                },
                orientation: 'portrait',  // Orientación Se establece en 'landscape' (horizontal) o 'portrait' (vertical).
                paperSize: 9,              // Tamaño de hoja (9 = A4, 1 = Carta)
                fitToPage: true,           // Ajustar a una sola página
                fitToWidth: 1,             // Ajustar al ancho de la página
                fitToHeight: 0             // Ajustar la altura automáticamente
            };




            // Combinar celdas correctamente
            worksheet.mergeCells('B1:H1');

            // Título en la celda combinada
            const titleCell = worksheet.getCell('B1');
            titleCell.value = 'REPORTE DE PACIENTES - CENTRO MÉDICO';
            titleCell.alignment = { horizontal: 'center' };
            titleCell.font = {
                size: 18,
                bold: true
            };

            // Definir las columnas según el rol
            let columns;
            if (this.userRole === 'administrador') {
                columns = [
                    { header: '#', key: 'numero', width: 5 },
                    { header: 'TIPO', key: 'tipo', width: 8 },
                    { header: 'CEDULA', key: 'cedula', width: 10 },
                    { header: 'PACIENTE', key: 'paciente', width: 35 },
                    { header: 'MÓVIL', key: 'movil', width: 14 },
                    { header: 'DOCTOR', key: 'doctor', width: 35 },
                    { header: 'ESPECIALIDAD', key: 'especialidad', width: 20 },
                    { header: 'ESTADO', key: 'estado', width: 9 },
                    { header: 'FECHA', key: 'fecha', width: 12 }
                ];
            } else {
                columns = [
                    { header: '#', key: 'numero', width: 5 },
                    { header: 'TIPO', key: 'tipo', width: 8 },
                    { header: 'CEDULA', key: 'cedula', width: 10 },
                    { header: 'PACIENTE', key: 'paciente', width: 35 },
                    { header: 'DOCTOR', key: 'doctor', width: 35 },
                    { header: 'ESPECIALIDAD', key: 'especialidad', width: 20 },
                    { header: 'ESTADO', key: 'estado', width: 9 },
                    { header: 'FECHA', key: 'fecha', width: 12 }
                ];
            }

            // Establecer las columnas y sus anchos
            columns.forEach((col, index) => {
                const column = worksheet.getColumn(index + 1);
                column.width = col.width;
            });

            // Establecer encabezados con estilos
            const headerRow = worksheet.getRow(4);
            columns.forEach((col, index) => {
                const cell = headerRow.getCell(index + 1);
                cell.value = col.header;
                cell.font = { size: 10, bold: true, color: { argb: 'FFFFFFFF' } };
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '0078be' } };
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });

            // Agregar los datos según el rol
            datos.forEach((paciente, index) => {
                const row = index + 5;  // Empezamos desde la fila 5
                const rowData = [];

                if (this.userRole === 'administrador') {
                    rowData.push(
                        index + 1,
                        paciente.tipo_identificacion,
                        paciente.cedula,
                        paciente.nombres_pacientes,
                        paciente.celular,
                        paciente.doctor,
                        paciente.especialidad,
                        paciente.estado,
                        moment(paciente.date_at).format('YYYY-MM-DD')
                    );
                } else {
                    rowData.push(
                        index + 1,
                        paciente.tipo_identificacion,
                        paciente.cedula,
                        paciente.nombres_pacientes,
                        paciente.doctor,
                        paciente.especialidad,
                        paciente.estado,
                        moment(paciente.date_at).format('YYYY-MM-DD')
                    );
                }

                // Agregar los datos a la hoja
                worksheet.addRow(rowData);

                // Si el estado es "Ausente", pintar la fila de rojo (#fe4141)
                if (paciente.estado === 'Ausente') {
                    const rowRange = worksheet.getRow(row);
                    rowRange.eachCell((cell) => {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FEFE4141' } // #fe4141 en formato ARGB
                        };
                    });
                }

                if (paciente.estado === 'En proceso') {
                    const rowRange = worksheet.getRow(row);
                    rowRange.eachCell((cell) => {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'b5fa7f' }
                        };
                    });
                }



            });



            // Generar y descargar el archivo Excel
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'listadoPacientes.xlsx';
            a.click();
            window.URL.revokeObjectURL(url);


            this.showOk('Archivo Generado')


        }

    }
};
</script>
